module.exports = __webpack_public_path__ + "media/Cartoon.65eae6a1.mp3";